<script setup>
import { Link } from '@inertiajs/inertia-vue3'
import { Inertia } from '@inertiajs/inertia'
import { ref, computed } from 'vue'

const props = defineProps({
  pagination: Object,
})

const goToPage = ref('')

const lastPage = computed(() => props.pagination?.last_page || 1)

const submitGoToPage = () => {
  const page = Number(goToPage.value)

  if (!page || page < 1 || page > lastPage.value) return

  const baseUrl = props.pagination?.links?.find(l => l.url)?.url
  if (!baseUrl) return

  const url = new URL(baseUrl, window.location.origin)
  url.searchParams.set('page', page)

  Inertia.get(url.toString(), {}, {
    preserveScroll: true,
    preserveState: true,
  })
}
</script>

<template>
  <nav
    class="flex flex-col items-start justify-between p-4 space-y-3 md:flex-row md:items-center md:space-y-0 border-b border-l border-r border-gray-200 rounded-b-lg"
    aria-label="Table navigation"
  >
    <ul class="inline-flex items-stretch">
      <li v-for="link in pagination.links" :key="link.label" class="mr-1">
        <span
          v-if="link.url === null || link.active"
          class="flex items-center justify-center px-3 h-8 text-sm font-medium text-gray-300 bg-white border border-gray-200 rounded-lg"
          v-html="link.label"
        />
        <Link
          v-else
          :href="link.url"
          class="flex items-center justify-center px-3 h-8 text-sm font-medium text-gray-500 bg-white border border-gray-300 rounded-lg hover:bg-gray-100 hover:text-gray-700 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white cursor-pointer"
          v-html="link.label"
        />
      </li>
    </ul>

    
    <div class="flex flex-col items-start gap-2 text-sm font-normal text-gray-500 md:flex-row md:items-center md:gap-6">
      <div class="flex items-center gap-2">
        <span>Go to page</span>
  
        <input
          v-model="goToPage"
          type="number"
          min="1"
          :max="lastPage"
          class="w-16 h-8 px-2 text-sm border border-gray-300 rounded-md focus:ring focus:ring-gray-200"
          @keyup.enter="submitGoToPage"
        />
  
        <button
          type="button"
          class="px-3 h-8 text-sm font-medium text-white bg-gray-700 rounded-md hover:bg-gray-800 disabled:opacity-50 disabled:cursor-not-allowed"
          :disabled="!goToPage || Number(goToPage) < 1 || Number(goToPage) > lastPage"
          @click="submitGoToPage"
        >
          Go
        </button>
  
        <span class="text-xs text-gray-400">
          (1–{{ lastPage }})
        </span>
      </div>
      <span>
        Showing
        <span class="font-semibold text-gray-900">{{ `${pagination.from || 0} - ${pagination.to || 0}` }}</span>
        of
        <span class="font-semibold text-gray-900">{{ `${pagination.total}` }}</span>
        Records
      </span>

    </div>
  </nav>
</template>